import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';

const AlternativeTextField = ({ fieldId, value }) => (
  <div className="mt-3">
    <div className="row alt-field-label">
      <LocalizedMessage id={fieldId} />
    </div>
    <div className="row alt-field-value">
      <span>{value}</span>
    </div>
  </div>
);

AlternativeTextField.propTypes = {
  fieldId: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
};

AlternativeTextField.defaultProps = {
  value: null,
};

module.exports = AlternativeTextField;



// WEBPACK FOOTER //
// ./components/permissions/AlternativeTextField.js